import { createContext } from 'react';

/**
 * Theme preference as the user expresses it. `system` means "follow OS"
 * (the default); `light` and `dark` are explicit overrides.
 */
export type ThemePreference = 'system' | 'light' | 'dark';

/**
 * Resolved theme — never `system`. Reflects what is actually rendered:
 * either `light` or `dark`. Useful when component code needs to read the
 * effective theme (e.g. picking a chart palette).
 */
export type ResolvedTheme = 'light' | 'dark';

export interface ThemeContextValue {
  /** User preference as stored in localStorage. */
  preference: ThemePreference;
  /** Effective theme after resolving `system` against the OS. */
  resolved: ResolvedTheme;
  /** Update the user preference. Persists to localStorage and re-renders. */
  setPreference: (next: ThemePreference) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
